<div class="table-responsive margin-top-15 table-view">
  <!-- For Leadership Common -->
  <div>
    <button [disabled]="DisableExport"
      class="btn btn-primary primary-btn button-excel"
      style="margin-bottom: 10px"
      (click)="exportToExcel()"
    >
      <i class="fa fa-file-excel-o"></i>Export To Excel
    </button>
    <h5 class="table-title">Leadership Common</h5>
    <p-table
      [value]="LeaderCommon"
      dataKey="id"
      [scrollable]="false"
      scrollHeight="500px"
      editMode="row"
      id="LeadershipCommonTableToExport"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 220px">Component</th>
          <th style="width: 40px">Jan</th>
          <th style="width: 40px">Feb</th>
          <th style="width: 40px">Mar</th>
          <th style="width: 40px">Apr</th>
          <th style="width: 40px">May</th>
          <th style="width: 40px">Jun</th>
          <th style="width: 40px">Jul</th>
          <th style="width: 40px">Aug</th>
          <th style="width: 40px">Sep</th>
          <th style="width: 40px">Oct</th>
          <th style="width: 40px">Nov</th>
          <th style="width: 40px">Dec</th>
          <th style="width: 60px">Ytd</th>
          <th style="width: 120px">Actions</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-common
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="common">
          <td style="width: 220px">
            {{ common.Component }}
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Jan"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 1, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Jan }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Feb"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 2, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Feb }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Mar"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 3, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Mar }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Apr"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 4, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Apr }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.May"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 5, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.May }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Jun"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 6, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Jun }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Jul"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 7, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Jul }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Aug"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 8, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Aug }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Sep"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 9, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Sep }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Oct"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 10, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Oct }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Nov"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 11, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Nov }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="common.Dec"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, common.Component, 12, 1)
                  "
                  data-target="#AT"
                >
                  {{ common.Dec }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <a
              data-toggle="modal"
              pTooltip="Get Details"
              tooltipPosition="top"
              (click)="
                GetLeaderBoardSelectedDetails(0, common.Component, 13, 1)
              "
              data-target="#AT"
            >
              {{ common.YTD }}</a
            >
          </td>
          <td>
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(common, 'Common')"
              class="p-button-rounded p-button-text"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(common, ri, 'Common')"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(common, ri, 'Common')"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- For Personal Safety -->
  <div style="margin-top: 60px">
    <h5 class="table-title">Personal Safety</h5>
    <p-table
      [value]="personalData"
      dataKey="id"
      [scrollable]="false"
      scrollHeight="500px"
      editMode="row"
      id="PersonalSafetyTableToExport"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 220px">Component</th>
          <th style="width: 40px">Jan</th>
          <th style="width: 40px">Feb</th>
          <th style="width: 40px">Mar</th>
          <th style="width: 40px">Apr</th>
          <th style="width: 40px">May</th>
          <th style="width: 40px">Jun</th>
          <th style="width: 40px">Jul</th>
          <th style="width: 40px">Aug</th>
          <th style="width: 40px">Sep</th>
          <th style="width: 40px">Oct</th>
          <th style="width: 40px">Nov</th>
          <th style="width: 40px">Dec</th>
          <th style="width: 60px">Ytd</th>
          <th style="width: 120px">Actions</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-personal
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="personal">
          <td style="width: 220px">
            {{ personal.Component }}
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Jan"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 1, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Jan }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Feb"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 2, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Feb }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Mar"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 3, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Mar }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Apr"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 4, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Apr }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.May"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 5, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.May }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Jun"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 6, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Jun }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Jul"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 7, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Jul }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Aug"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 8, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Aug }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Sep"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 9, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Sep }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Oct"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 10, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Oct }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Nov"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 11, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Nov }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="personal.Dec"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, personal.Component, 12, 1)
                  "
                  data-target="#AT"
                >
                  {{ personal.Dec }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <a
              data-toggle="modal"
              pTooltip="Get Details"
              tooltipPosition="top"
              (click)="
                GetLeaderBoardSelectedDetails(0, personal.Component, 13, 1)
              "
              data-target="#AT"
            >
              {{ personal.YTD }}</a
            >
          </td>
          <td>
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(personal, 'Personal')"
              class="p-button-rounded p-button-text"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(personal, ri, 'Personal')"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(personal, ri, 'Personal')"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- For Process Safety -->
  <!-- <div style="margin-top: 60px">
    <h5 class="table-title">Process Safety</h5>
    <p-table
      [value]="processData"
      dataKey="id"
      [scrollable]="true"
      scrollHeight="500px"
      editMode="row"
      id="ProcessSafetyTableToExport"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 220px">Component</th>
          <th style="width: 40px">Jan</th>
          <th style="width: 40px">Feb</th>
          <th style="width: 40px">Mar</th>
          <th style="width: 40px">Apr</th>
          <th style="width: 40px">May</th>
          <th style="width: 40px">Jun</th>
          <th style="width: 40px">Jul</th>
          <th style="width: 40px">Aug</th>
          <th style="width: 40px">Sep</th>
          <th style="width: 40px">Oct</th>
          <th style="width: 40px">Nov</th>
          <th style="width: 40px">Dec</th>
          <th style="width: 60px">Ytd</th>
          <th style="width: 120px">Actions</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-process
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="process">
          <td>
            {{ process.Component }}
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Jan"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 1, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Jan }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Feb"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 2, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Feb }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Mar"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 3, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Mar }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Apr"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 4, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Apr }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.May"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 5, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.May }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Jun"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 6, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Jun }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Jul"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 7, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Jul }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Aug"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 8, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Aug }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Sep"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 9, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Sep }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Oct"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 10, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Oct }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Nov"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 11, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Nov }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Dec"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 12, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Dec }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <a
              data-toggle="modal"
              pTooltip="Get Details"
              tooltipPosition="top"
              (click)="
                GetLeaderBoardSelectedDetails(0, process.Component, 13, 2)
              "
              data-target="#AT"
            >
              {{ process.YTD }}</a
            >
          </td>
          <td>
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(process, 'Process')"
              class="p-button-rounded p-button-text"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(process, ri, 'Process')"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(process, ri, 'Process')"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div> -->

  <div style="margin-top: 60px">
    <h5 class="table-title">Process Safety</h5>
    <p-table
      [value]="processData"
      dataKey="id"
      [scrollable]="false"
      scrollHeight="500px"
      editMode="row"
      id="ProcessSafetyTableToExport"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 220px">Component</th>
          <th style="width: 40px">Jan</th>
          <th style="width: 40px">Feb</th>
          <th style="width: 40px">Mar</th>
          <th style="width: 40px">Apr</th>
          <th style="width: 40px">May</th>
          <th style="width: 40px">Jun</th>
          <th style="width: 40px">Jul</th>
          <th style="width: 40px">Aug</th>
          <th style="width: 40px">Sep</th>
          <th style="width: 40px">Oct</th>
          <th style="width: 40px">Nov</th>
          <th style="width: 40px">Dec</th>
          <th style="width: 60px">Ytd</th>
          <th style="width: 120px">Actions</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-process
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="process">
          <td style="width: 220px">
            {{ process.Component }}
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Jan"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 1, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Jan }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Feb"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 2, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Feb }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Mar"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 3, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Mar }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Apr"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 4, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Apr }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.May"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 5, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.May }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Jun"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 6, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Jun }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Jul"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 7, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Jul }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Aug"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 8, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Aug }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Sep"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 9, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Sep }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Oct"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 10, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Oct }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Nov"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 11, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Nov }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="process.Dec"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                <a
                  data-toggle="modal"
                  pTooltip="Get Details"
                  tooltipPosition="top"
                  (click)="
                    GetLeaderBoardSelectedDetails(0, process.Component, 12, 2)
                  "
                  data-target="#AT"
                >
                  {{ process.Dec }}</a
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <a
              data-toggle="modal"
              pTooltip="Get Details"
              tooltipPosition="top"
              (click)="
                GetLeaderBoardSelectedDetails(0, process.Component, 13, 2)
              "
              data-target="#AT"
            >
              {{ process.YTD }}</a
            >
          </td>
          <td>
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(process, 'Process')"
              class="p-button-rounded p-button-text"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(process, ri, 'Process')"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(process, ri, 'Process')"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  
</div>

<div
  class="modal fade PDModal"
  data-backdrop="static"
  style="opacity: 1 !important"
  id="AT"
  role="dialog"
>
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close button-cancel" data-dismiss="modal">
          &times;
        </button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of LeaderData; let i = index">
            <li *ngIf="item.Text.includes('ACT')">
              <a (click)="Redirect2(item.value, item.ID)">{{ item.Text }}</a>
            </li>
            <li *ngIf="item.Text.includes('OBS')">
              <a (click)="Redirect1(item.value, item.ID)">{{ item.Text }}</a>
            </li>
            <li *ngIf="item.Text.includes('INC')">
              <a (click)="Redirect(item.value, item.ID)">{{ item.Text }}</a>
            </li>
          </ng-container>
        </ol>
        <span *ngIf="LeaderData?.length < 1" style="color: red"
          >No Records Found..</span
        >
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
